import {
    Configuration,
    DownloadHistoryApi,
    PasswordApi,
    UserApi,
    UserSessionApi,
} from '@videoblocks/user-service-client';

export const config = new Configuration({
    basePath: process.env.USER_SERVICE_HOST ?? 'http://host.docker.internal:3200',
});

export const userApi = new UserApi(config);
export const userSessionApi = new UserSessionApi(config);
export const passwordApi = new PasswordApi(config);
export const downloadHistoryApi = new DownloadHistoryApi(config);
